import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const store = new Vuex.Store({
    actions: {},
    state: {},
    mutations: {}
});

export default store;



// WEBPACK FOOTER //
// ./src/store/base/attributes.js